module.exports = __webpack_public_path__ + "img/arrowcircle.7767b379.svg";